import { FC } from 'react';
import { Calendar } from 'react-multi-date-picker';
import styles from './date-picker.module.scss';
import { Button } from '@chakra-ui-kraud/react';
import dayjs from 'dayjs';
import { DatePickerProps } from './date-picker.types';
import { DEFAULT_YEAR_FORMAT } from '@/shared';

export const DatePicker: FC<DatePickerProps> = ({ handleChange, reset, value }) => {
	return (
		<div className={styles['date-picker']}>
			<Calendar
				className={styles['date-picker__calendar']}
				value={value}
				onChange={handleChange}
				range
				weekDays={['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ']}
				weekStartDayIndex={1}
				showOtherDays
				highlightToday={false}
				shadow={false}
			/>
			<div className={styles['date-picker__info']}>
				{value.length ? (
					<p>
						<span>{value[0] ? dayjs(value[0]).format(DEFAULT_YEAR_FORMAT) : 'Не выбрано'}</span> –{' '}
						<span>{value[1] ? dayjs(value[1]).format(DEFAULT_YEAR_FORMAT) : 'Не выбрано'}</span>
					</p>
				) : (
					'*Выберите диапазон дат'
				)}

				<Button
					size="xs"
					marginTop="6px"
					variant="outline"
					colorScheme="tertiary"
					onClick={reset}
					className={styles['date-picker__reset-btn']}
				>
					Cбросить
				</Button>
			</div>
		</div>
	);
};
